import { Component, OnInit } from '@angular/core';
import {
  TableData,
  TablesComponent,
} from '../../components/tables/tables.component';
import { CommonModule, DatePipe } from '@angular/common';
import {
  AdminReportFilterModel,
  ReportService,
} from '../../../core/services/report/report.service';
import { UsersService } from '../../../core/services/user/users.service';
import { TranslateService } from '@ngx-translate/core';
import { ColumnModel } from '../../../core/models/table/column.model';
import { FilterModel } from '../../../core/models/filters/filters.model';
import { SortModel } from '../../../core/models/filters/sort.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-branch-report-list',
  standalone: true,
  imports: [TablesComponent, CommonModule, DatePipe],
  templateUrl: './branch-report-list.component.html',
  styleUrl: './branch-report-list.component.scss',
  providers: [DatePipe],
})
export class BranchReportListComponent implements OnInit {
  maxDate: string;
  tableHeader: string;
  columns: ColumnModel[] = [];
  data: TableData[] = [];
  url: string =  `${environment.apiLocations.patient}/OrganizationAdminReport/GetAnalysisReportCountByCustomerBranch`
  totalCount: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;
  filters: FilterModel[] = [
  
    //Year
    {
      type: 'date',
      label: 'year',
      placeholder: 'dd-mm-yyyy',
      filterId: 'Year',
      value: null,
    },
    //Month
    {
      type: 'date',
      label: 'month',
      placeholder: 'dd-mm-yyyy',
      filterId: 'Month',
      value: null,
    },  
  ];
 

  constructor(
    private reportService: ReportService,
    private userService: UsersService,
    private translate: TranslateService
  ) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];

    this.columns = [
      { key: 'customerBranchName', translateKey: 'customerBranchName' },
      { key: 'year', translateKey: 'year' },
      { key: 'month', translateKey: 'month' },
      { key: 'totalImageCount', translateKey: 'totalImageCount' },
      { key: 'totalAnalysisCount', translateKey: 'totalAnalysisCount' },
    ];
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    setTimeout(() => {
      this.tableHeader = this.translate.instant('branchAnalysisReport');
    }, 100);
  }
  ngOnInit(): void {
    // this.getBranchReportList(this.currentPage, this.pageSize);
  }

  async getBranchReportList(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): Promise<void> {
    const userBranches = await this.userService.getUserBranchesByCustomerCode();

    const updatedFilters = {
      ...filters,

      userBranches: userBranches || [],
    };

    this.reportService
      .getAnalysisReportCountByCustomerBranch(page, size, updatedFilters, sort)
      .subscribe({
        next: (res) => {
          this.data = res.items;
          this.totalCount = res.count;
          this.totalPage = res.pages;
          this.pageSize = res.size;
          this.currentPage = page;
        },
      });
  }

  onChangeFilterValues(filters?: FilterModel[], sort?: SortModel) {
    this.getBranchReportList(1, this.pageSize, filters, sort);
  }

  changePage(e: any): void {
    if (e.page > 0 && e.page <= this.totalPage) {
      this.getBranchReportList(e.page, e.pageSize, this.filters);
    }
  }
}
